"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Packages */

/* Icon Itself */
var IconPaymentDiscover = function IconPaymentDiscover(props) {
  /**
   * Inherit props
   */
  var size = props.size,
      width = props.width,
      height = props.height;
  /**
   * Render
   */

  return _react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: width || size,
    height: height || size,
    viewBox: "0 0 30 30"
  }, _react.default.createElement("defs", null, _react.default.createElement("rect", {
    id: "path-1",
    x: "0",
    y: "4",
    width: "30",
    height: "22.5",
    rx: "2"
  })), _react.default.createElement("g", {
    id: "Pagamento-/-Discover",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, _react.default.createElement("use", {
    xlinkHref: "#path-1"
  })), _react.default.createElement("use", {
    id: "Fundo",
    fill: "#F3F2F2",
    xlinkHref: "#path-1"
  }), _react.default.createElement("g", {
    id: "Discover",
    mask: "url(#mask-2)"
  }, _react.default.createElement("g", {
    transform: "translate(2.500000, 11.000000)"
  }, _react.default.createElement("ellipse", {
    id: "Oval",
    fill: "#F26E21",
    fillRule: "evenodd",
    cx: "13.2893333",
    cy: "2.11932203",
    rx: "2.07866667",
    ry: "2.11389831"
  }), _react.default.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "evenodd",
    points: "5.70733333 7.85986441 5.70733333 5.60237288 7.223 7.21498305 7.223 5.74589831 7.5368 5.74589831 7.5368 7.98840678 6.02113333 6.37959322 6.02113333 7.85952542 5.70733333 7.85952542"
  }), _react.default.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "evenodd",
    points: "9.18193333 6.04583051 8.34853333 6.04583051 8.34853333 6.55369492 9.15773333 6.55369492 9.15773333 6.85376271 8.34853333 6.85376271 8.34853333 7.56 9.18193333 7.56 9.18193333 7.85986441 8.03493333 7.85986441 8.03493333 5.74623729 9.18193333 5.74623729 9.18193333 6.04583051"
  }), _react.default.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "evenodd",
    points: "10.1672667 6.04583051 10.1672667 7.85966102 9.85346667 7.85966102 9.85346667 6.04583051 9.3758 6.04583051 9.3758 5.7459661 10.644 5.7459661 10.644 6.04583051"
  }), _react.default.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "evenodd",
    points: "11.1500667 5.74623729 11.6914 7.15898305 12.2571333 5.64352542 12.7982 7.15898305 13.3729333 5.74623729 13.7136667 5.74623729 12.7847333 7.99410169 12.2501333 6.49640678 11.6928667 7.99566102 10.8095333 5.74630508"
  }), _react.default.createElement("path", {
    d: "M13.7738,6.79362712 C13.7738,6.49579661 13.8813333,6.24033898 14.0956,6.02698305 C14.3091333,5.81335593 14.5660667,5.70657627 14.8659333,5.70657627 C15.162,5.70657627 15.416,5.81416949 15.6277333,6.02949153 C15.8405333,6.24515254 15.9465333,6.50359322 15.9465333,6.8060339 C15.9465333,7.10969492 15.8398,7.36766102 15.6264667,7.57952542 C15.4119333,7.79213559 15.153,7.89864407 14.8496667,7.89864407 C14.5815333,7.89864407 14.3402667,7.804 14.1267333,7.61525424 C13.8915333,7.4060339 13.7738,7.1320678 13.7738,6.79362712 Z M14.0903333,6.79694915 C14.0903333,7.03030508 14.1676667,7.22210169 14.3218,7.37281356 C14.4752,7.52352542 14.6526,7.59857627 14.8538667,7.59857627 C15.0716667,7.59857627 15.2557333,7.5219661 15.4056667,7.36901695 C15.5556,7.2140339 15.6304,7.02528814 15.6304,6.80277966 C15.6304,6.57728814 15.5563333,6.38854237 15.4081333,6.23654237 C15.2609333,6.08332203 15.0788667,6.00671186 14.8616,6.00671186 C14.6453333,6.00671186 14.4627333,6.08332203 14.3140667,6.23654237 C14.1649333,6.38725424 14.0903333,6.57444068 14.0903333,6.79694915 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }), _react.default.createElement("path", {
    d: "M17.0451333,6.95905085 L17.6887333,7.85986441 L17.3050667,7.85986441 L16.7114,6.99484746 L16.6548,6.99484746 L16.6548,7.85986441 L16.341,7.85986441 L16.341,5.74623729 L16.7084667,5.74623729 C16.9833333,5.74623729 17.1814,5.79877966 17.3036667,5.90379661 C17.4384,6.02047458 17.5057333,6.17471186 17.5057333,6.36650847 C17.5057333,6.51620339 17.4636,6.64481356 17.379,6.75233898 C17.2945333,6.85986441 17.1835333,6.92908475 17.0451333,6.95905085 Z M16.6549333,6.71674576 L16.7542,6.71674576 C17.0512667,6.71674576 17.2,6.60128814 17.2,6.37044068 C17.2,6.1540339 17.0555333,6.0459661 16.7664667,6.0459661 L16.6549333,6.0459661 L16.6549333,6.71674576 L16.6549333,6.71674576 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }), _react.default.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "evenodd",
    points: "18.3148 6.58942373 19.1238 5.74616949 19.5426 5.74616949 18.6029333 6.70332203 19.5481333 7.85986441 19.1280667 7.85986441 18.3794667 6.91945763 18.3148667 6.98542373 18.3148667 7.85986441 18.0010667 7.85986441 18.0010667 5.74623729 18.3148667 5.74623729 18.3148667 6.58942373"
  }), _react.default.createElement("g", {
    id: "Group",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement("path", {
    d: "M2.0938,3.13152542 C1.84886667,3.35450847 1.5328,3.45118644 1.03086667,3.45118644 L0.8226,3.45118644 L0.8226,0.797220339 L1.03086667,0.797220339 C1.53273333,0.797220339 1.83633333,0.887525424 2.0938,1.12189831 C2.3622,1.36264407 2.52233333,1.73532203 2.52233333,2.12040678 C2.52233333,2.50569492 2.3622,2.89152542 2.0938,3.13152542 L2.0938,3.13152542 Z M1.18653333,0.117559322 L0.0460666667,0.117559322 L0.0460666667,4.13023729 L1.1808,4.13023729 C1.783,4.13023729 2.21826667,3.98664407 2.6002,3.66705085 C3.0532,3.2880678 3.32213333,2.71654237 3.32213333,2.12569492 C3.32206667,0.941016949 2.44453333,0.117559322 1.18653333,0.117559322 L1.18653333,0.117559322 Z",
    id: "Shape",
    fill: "#0B161F",
    fillRule: "nonzero"
  }), _react.default.createElement("polyline", {
    id: "Path",
    fill: "#0B161F",
    points: "3.68 4.13023729 4.45533333 4.13023729 4.45533333 0.117559322 3.68 0.117559322 3.68 4.13023729"
  }), _react.default.createElement("path", {
    d: "M6.3534,1.65688136 C5.8874,1.48257627 5.7502,1.3679322 5.7502,1.15233898 C5.7502,0.899389831 5.9944,0.706847458 6.32893333,0.706847458 C6.56166667,0.706847458 6.75226667,0.802983051 6.95606667,1.03105085 L7.36093333,0.496271186 C7.0272,0.201016949 6.62753333,0.050779661 6.19153333,0.050779661 C5.48806667,0.050779661 4.95073333,0.54420339 4.95073333,1.19918644 C4.95073333,1.75349153 5.20093333,2.0360678 5.92933333,2.30142373 C6.23366667,2.40922034 6.38833333,2.48101695 6.46613333,2.5299661 C6.62106667,2.63247458 6.69913333,2.77627119 6.69913333,2.94474576 C6.69913333,3.27023729 6.44246667,3.51044068 6.09593333,3.51044068 C5.726,3.51044068 5.42793333,3.32427119 5.2488,2.97518644 L4.7484,3.46298305 C5.1056,3.99166102 5.5352,4.22732203 6.12633333,4.22732203 C6.93153333,4.22732203 7.49806698,3.68494915 7.49806698,2.90922034 C7.4984,2.27105085 7.23646667,1.98210169 6.3534,1.65688136",
    id: "Path",
    fill: "#0B161F"
  }), _react.default.createElement("path", {
    d: "M7.74286667,2.12569492 C7.74286667,3.30630508 8.66186667,4.22081356 9.84326667,4.22081356 C10.1775333,4.22081356 10.4634,4.15410169 10.8158667,3.98664407 L10.8158667,3.06508475 C10.5053333,3.37837288 10.2306667,3.50447458 9.87866667,3.50447458 C9.09713333,3.50447458 8.54213333,2.93267797 8.54213333,2.12013559 C8.54213333,1.35023729 9.11486667,0.742169492 9.84326667,0.742169492 C10.2124667,0.742169492 10.4933333,0.874305085 10.8158667,1.19349153 L10.8158667,0.272610169 C10.4761333,0.0985762712 10.195,0.026779661 9.86073333,0.026779661 C8.68573333,0.0270508475 7.74286667,0.95979661 7.74286667,2.12569492",
    id: "Path",
    fill: "#0B161F"
  }), _react.default.createElement("polyline", {
    id: "Path",
    fill: "#0B161F",
    points: "17.1037333 2.81294915 16.0415333 0.117559322 15.1944 0.117559322 16.8834667 4.23301695 17.3005333 4.23301695 19.0192667 0.117559322 18.1778667 0.117559322 17.1037333 2.81294915"
  }), _react.default.createElement("polyline", {
    id: "Path",
    fill: "#0B161F",
    points: "19.3717333 4.13023729 21.5728667 4.13023729 21.5728667 3.45118644 20.1472667 3.45118644 20.1472667 2.36698305 21.5182667 2.36698305 21.5182667 1.68786441 20.1472667 1.68786441 20.1472667 0.797152542 21.5728667 0.797152542 21.5728667 0.117559322 19.3717333 0.117559322 19.3717333 4.13023729"
  }), _react.default.createElement("path", {
    d: "M23.0875333,1.96461017 L22.8615333,1.96461017 L22.8615333,0.748474576 L23.0997333,0.748474576 C23.5839333,0.748474576 23.8466,0.953966102 23.8466,1.34433898 C23.8466,1.74718644 23.5839333,1.96461017 23.0875333,1.96461017 L23.0875333,1.96461017 Z M24.6446,1.30176271 C24.6446,0.550101695 24.132,0.117559322 23.2364667,0.117559322 L22.0852667,0.117559322 L22.0852667,4.13023729 L22.8613333,4.13023729 L22.8613333,2.51762712 L22.9631333,2.51762712 L24.0362667,4.13023729 L24.9909333,4.13023729 L23.7374667,2.43972881 C24.3230667,2.31952542 24.6446,1.9159322 24.6446,1.30176271 L24.6446,1.30176271 Z",
    id: "Shape",
    fill: "#0B161F",
    fillRule: "nonzero"
  }))))));
};
/* Exporting */


var _default = IconPaymentDiscover;
exports.default = _default;